// transformAudienceSchema.js

export const transformAudienceSchema = audienceSchema => {
  if (!audienceSchema || !audienceSchema.internalMicroserviceAudienceSchema) {
    return {
      groupedCategories: {},
      categories: [],
    };
  }

  const dimensions =
    audienceSchema.internalMicroserviceAudienceSchema.dimensions;

  const groupedCategories = dimensions.reduce((acc, obj) => {
    const category = obj.category.name;
    if (!acc[category]) {
      acc[category] = {
        name: category,
        description: obj.category.description,
        datapoints: [],
      };
    }
    acc[category].datapoints.push({
      name: obj.datapoint,
      description: obj.description,
      type: obj.type,
      mappings: obj.mappings,
    });
    return acc;
  }, {});

  return {
    groupedCategories: groupedCategories,
  };
};
